
const digest = '56a3801f8cfd181b40aa77f44ce0431ae773bacd548a47635c983639e2b8fc5d';
const classes = {"wrapper":"_wrapper_1k2w8_1","tableWrapper":"_tableWrapper_1k2w8_10"};
const css = `._wrapper_1k2w8_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  min-height: 0;
}

._tableWrapper_1k2w8_10 {
  flex: 1;
  min-height: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  